
import { Component, Vue } from "vue-property-decorator";

@Component
export default class LimitDialog extends Vue {
  dialog = false;

  show() {
    this.dialog = true;
  }
}
